import { render, staticRenderFns } from "./ConfirmacaoEvento.vue?vue&type=template&id=730e1022&scoped=true"
import script from "./ConfirmacaoEvento.vue?vue&type=script&lang=js"
export * from "./ConfirmacaoEvento.vue?vue&type=script&lang=js"
import style0 from "./ConfirmacaoEvento.vue?vue&type=style&index=0&id=730e1022&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730e1022",
  null
  
)

export default component.exports